import { createApi } from '@reduxjs/toolkit/query/react';
import { baseApiQuery } from '../basequery';

export interface FeatureFlag {
  id: string;
  isEnabled: boolean;
  description?: string;
}

export interface FeatureFlagsResponse {
  data: {
    flags: FeatureFlag[];
  };
}

export const featureFlagsApi = createApi({
  reducerPath: 'featureFlagsApi',
  baseQuery: baseApiQuery,
  tagTypes: ['FeatureFlags'],
  endpoints: (builder) => ({
    /**
     * Fetches UI feature flags that are available to all users.
     * These flags serve as baseline values for the frontend.
     */
    getFeatureFlags: builder.query<FeatureFlagsResponse, void>({
      query: () => ({
        url: '/features/ui',
        method: 'GET',
      }),
      providesTags: ['FeatureFlags'],
    }),
    /**
     * Fetches UI feature flags that require authentication.
     * These flags are only available to signed-in users and may override baseline values from the public flags.
     */
    getSecureFeatureFlags: builder.query<FeatureFlagsResponse, void>({
      query: () => ({
        url: '/features/ui/secure',
        method: 'GET',
      }),
      providesTags: ['FeatureFlags'],
    }),
  }),
});

export const {
  useGetFeatureFlagsQuery,
  useGetSecureFeatureFlagsQuery,
  useLazyGetFeatureFlagsQuery,
  useLazyGetSecureFeatureFlagsQuery,
} = featureFlagsApi;
